import { ActionTypes } from '../actions/CompanyActions';
// import Helpers         from 'app/utils/helpers/Helpers';

var initial_state = {};

var callables = {
	[ActionTypes.update_company](state, action) {
		return Object.assign({}, state, action.company);
	},

};

export default function(state = initial_state, action) {

	if (callables.hasOwnProperty(action.type)) {
		return callables[action.type](state, action);
	}

	return state;
};